<template>
  <div class="QuotaManage">
    <router-view></router-view>
  </div>
</template>

<script>
import F404Page from '../../../../404Page'
export default {
  components: { F404Page },
  props: {},
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
</style>